import { CalcBorderWidth } from "../utils/CalcBorderWidth";
import { CreateMeasureBuffer } from "../utils/CreateMeasureBuffer";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumElementBorderStyle,
  enumElementDrawStates,
  enumElementLayer,
  enumFillMode,
  enumPanelRenderMode,
  enumShortCutModKeys,
  kReturnKey
} from "../constants";
import { uFramelessPanelColorDarker } from "../whitelabel/brand";
import { getHoverTip } from "../utils/getHoverTip";
import { QElemDragInfoObj } from "./QElemDragInfoObj";
// import { QElementDragPanel } from "./QElementDragPanel";
import { QHoverMsg } from "./QHoverMsg";
import { QPoint } from "./QPoint";
import { QRect } from "./QRect";
import { QResizeBehavior } from "../utils/QResizeBehavior";
import { QUIObject } from "./QUIObject";
import { Globals } from "./Globals";
import { CreatePath2D } from "../utils/CreatePath2D.js";

export class QElement extends QUIObject {
  constructor() {
    super();
    this.fHorzOffset = 1;
    this.fVertOffset = 1;
    this.fWidth = 1;
    this.fHeight = 1;
    this.fCurDrawState = enumElementDrawStates.Std;
    this.fEnabled = true;
    this.fCmdCode = "0000"; // Cleanup to null
    this.fDblClickCmd = null;

    this.fCmdShortCut = null;
    this.fCmdShortCutModKeys = null;
    this.fCmdShortCutText = "";
    this.fIsFuncShortCut = false;

    this.fFillColor = "#AA55BB";
    this.fFillColor2 = null;
    this.fAlpha = 1;

    this.fFillMode = enumFillMode.solidFill;

    this.fDragable = false;
    this.fIsSelectable = false;

    this.fSelected = false;
    this.fElementID = 0;

    // Control handling
    this.fControl = false;
    this.fCtrlInteractiveCmd = false;
    this.fControlReleaseCmdCode = null;
    //this.fPassControl = false;

    // Border properties
    this.fBorderThickness = 1;
    this.fBorderStyle = enumElementBorderStyle.noBorder;
    this.fBorderColor = "#000000";

    // Shadow on/off
    this.fShowShadow = false;
    this.fHoverCode = null;
    this.fRawHoverValue = null;

    this.fElementResizeBehavior = null;
    this.fShown = true;

    this.fAcceptsClicks = true;
    this.fElementType = -1;

    this.fWantsKeyboardInput = false;

    this.fElementGroup = null;
    this.fZPlane = 0;

    this.fMeasureBuffer = null;
    this.fLayer = enumElementLayer.content;

    this.fDragStartCmd = null;
    this.fSubElement = null;
    this.fRenderHighlightSelectionBeneathText = false;
    this.fParentPanelRef = null;
    this.fHitDetectThreshold = 0;
  }

  GetHelpCode() {
    //Scope change here allows us to use non-QHelpbuttons to still launch the help system.
    return this.fHelpCode;
  }

  SetParentPanelRef(parentPanel) {
    this.fParentPanelRef = parentPanel;
  }

  GetParentPanelRef() {
    return this.fParentPanelRef;
  }

  DoCloseElement() {
    // Override this is needed
  }

  CloseElement() {
    this.DoCloseElement();
  }

  Reselect() {}

  GetCursor() {
    return this.fCurCursor;
  }

  SetRenderHighlightBeneathText(renderSelectionBeneathText) {
    this.fRenderHighlightSelectionBeneathText = renderSelectionBeneathText;
  }

  GetRenderHighlightBeneathText() {
    return this.fRenderHighlightSelectionBeneathText;
  }

  SetCursor(mode) {
    this.fCurCursor = mode;
  }

  HasSubCursor() {
    return false;
  }

  GetSubCursor(hitTest) {
    return null;
  }

  SetWidth(theWidth) {
    this.fWidth = theWidth;
  }

  GetWidth() {
    return this.fWidth;
  }

  GetHeight() {
    return this.fHeight;
  }

  SetHeight(theHeight) {
    this.fHeight = theHeight;
  }

  // Element Types
  SetElementType(elementType) {
    this.fElementType = elementType;
  }

  GetElementType() {
    return this.fElementType;
  }

  IsShown() {
    return this.fShown;
  }

  SetShownState(showElement) {
    this.fShown = showElement;
  }

  // Border Thickness
  SetBorderThickness(thickness) {
    this.fBorderThickness = thickness;
  }

  GetBorderThickness() {
    return this.fBorderThickness;
  }

  // UI Color
  SetUIColors(colorObj) {
    this.fUIColors = colorObj;
  }

  // Border Color
  SetBorderColor(borderColor) {
    this.fBorderColor = borderColor;
  }

  GetBorderColor() {
    return this.fBorderColor;
  }

  // Border Style
  SetBorderStyle(borderStyle) {
    this.fBorderStyle = borderStyle;
  }

  GetBorderStyle() {
    return this.fBorderStyle;
  }

  SetBorderRadius(radius) {
    this.fBorderRadius = radius;
  }

  // Shadow On/Off
  SetShadowOn(shadowOn) {
    this.fShowShadow = shadowOn;
  }

  GetShadowOn() {
    return this.fShowShadow;
  }

  PositionElement(x, y) {
    this.fHorzOffset = x;
    this.fVertOffset = y;

    //this.DoPositionElement();
  }

  PushElement(anElement) {
    //We assume this is a flat structure
    if (this.fElements == null) this.fElements = [];
    anElement.fParentElement = this;
    this.fElements.push(anElement);
    anElement.SetParentPanelRef(this.GetParentPanelRef());
  }

  RemoveElement(anElement) {
    var index = this.fElements.indexOf(anElement);
    if (index != -1) {
      //this.DoCloseElement(anElement);	//TODO: Might need to restore later.
      this.fElements.splice(index, 1);
      return true;
    }

    return false;
  }

  GetParentElement() {
    return this.fParentElement;
  }

  MoveElement(deltaX, deltaY) {
    var xPanel = this.GetPositionX();
    var yPanel = this.GetPositionY();

    var newX = xPanel + deltaX;
    var newY = yPanel + deltaY;
    /*
	if (this.fDragConstrain)
	{
		if (newX > this.fDragMaxX)
			newX = this.fDragMaxX;
		if (newX < this.fDragMinX)
			newX = this.fDragMinX;
		if (newY > this.fDragMaxY)
			newY = this.fDragMaxY;
		if (newY < this.fDragMinY)
			newY = this.fDragMinY;
	}
	*/
    this.PositionElement(newX, newY);
  }

  GetPositionX() {
    return this.fHorzOffset;
  }

  GetElementWidth() {
    return this.GetWidth();
  }

  GetWidthPositionX(buffer) {
    if (!buffer) buffer = 0;
    return this.fHorzOffset + this.GetElementWidth() + buffer;
  }

  GetHeightPositionY(buffer) {
    if (!buffer) buffer = 0;
    return this.fVertOffset + this.fHeight + buffer;
  }

  SetPositionX(x) {
    this.fHorzOffset = x;
  }

  SetPositionY(y) {
    this.fVertOffset = y;
  }

  GetPositionY() {
    return this.fVertOffset;
  }

  SizeElement(hSize, vSize) {
    this.SetWidth(hSize);
    this.SetHeight(vSize);
  }

  GetDrawState() {
    return this.fCurDrawState;
  }

  GetParentDrawState() {
    var parentElement = this.GetParentElement();
    if (!parentElement) return this.fCurDrawState;

    if (parentElement.fElements) {
      for (let anElement in parentElement.fElements) {
        let theElement = parentElement.fElements[anElement];
        if (theElement.fCurDrawState == enumElementDrawStates.Hover)
          return theElement.fCurDrawState;
      }
    }
    return parentElement.fCurDrawState;
  }

  SetDrawState(theState) {
    this.fCurDrawState = theState;
  }

  HoverTarget(becomeTarget) {
    //TODO: This baseclass fxn used to be empty, but there's utility in having this bool set at the baseclass level and having a "doafterhovertarget" for the subclasses.

    //May need to revisit if we deicde to lean on this harder and chartbox and chartboxcell are naughty.
    this.fIsHoverTarget = becomeTarget;
  }

  SetFillColor(fillColor) {
    this.fFillColor = fillColor;
  }

  GetFillColor() {
    return this.fFillColor;
  }

  SetFillColor2(fillColor) {
    this.fFillColor2 = fillColor;
  }

  GetFillColor2() {
    return this.fFillColor2;
  }

  SetFillMode(fillMode) {
    this.fFillMode = fillMode;
  }

  GetFillMode() {
    return this.fFillMode;
  }

  SetGradientColors(startColor, endColor, middleColor) {
    this.fFillGradientStart = startColor;
    this.fFillGradientEnd = endColor;
    this.fFillMiddleColor = middleColor;
    this.fGradient = null;
  }

  DoGetGradientVals() {
    var p = new QPoint();
    p.InitPoint(this.fFillGradientStart, this.fFillGradientEnd);
    if (this.fFillMiddleColor) p.fZ = this.fFillMiddleColor;
    return p;
  }

  IsGradientFill() {
    return (
      this.fFillMode === enumFillMode.linearGradientAcross ||
      this.fFillMode === enumFillMode.linearGradientDown
    );
  }

  GetGradient(ctx) {
    var createGradient = this.fGradient == null || this.fForceRender;
    if (createGradient) {
      var fillMode = this.GetFillMode();
      var gradient =
        fillMode === enumFillMode.linearGradientDown
          ? ctx.createLinearGradient(0, 0, 0, this.fHeight)
          : ctx.createLinearGradient(0, 0, this.fWidth, 0);
      var p = this.DoGetGradientVals();
      gradient.addColorStop(0, p.fX);
      if (p.fZ) gradient.addColorStop(0.5, p.fZ);
      gradient.addColorStop(1, p.fY);

      this.fGradient = gradient;
    }

    return this.fGradient;
  }

  // Hooks an element to a document
  GetElementID() {
    return this.fElementID;
  }

  SetElementID(elementID) {
    this.fElementID = elementID;
  }

  IsEnabled() {
    return this.fEnabled;
  }

  DoSetEnabled(enabled) {
    // Override this
  }

  SetEnabled(enabled) {
    this.DoSetEnabled(enabled);

    if (this.fEnabled != enabled) {
      this.fEnabled = enabled;
      if (this.fEnabled) this.SetDrawState(enumElementDrawStates.Std);
      else this.SetDrawState(enumElementDrawStates.Disabled);
    }

    return enabled;
  }

  // Selection handling
  IsSelectable() {
    return this.fIsSelectable;
  }

  SetIsSelectable(selectable) {
    this.fIsSelectable = selectable;
  }

  IsSelected() {
    return this.fSelected;
  }

  DoSetSelected(priorState, selected) {
    // Override this if needed
  }

  SetSelected(selected) {
    //	if (this.fSelected == selected)
    //		return;
    //if (selected == true)
    //	console.log("Select Element");

    var priorState = this.fSelected;
    this.fSelected = selected;
    this.DoSetSelected(priorState, selected);
  }

  //======================================================
  // active states
  IsHighlighted() {
    return this.fIsHighlighted;
  }

  DoSetHighlighted(priorState, activated) {
    // Override this if needed
  }

  SetHighlighted(highlight) {
    //	if (this.fSelected == selected)
    //		return;
    //if (selected == true)
    //	console.log("Select Element");

    var priorState = this.fIsHighlighted;
    this.fIsHighlighted = highlight;
    this.DoSetHighlighted(priorState, highlight);
  }

  SetAcceptsClicks(acceptsClicks) {
    this.fAcceptsClicks = acceptsClicks;
  }

  SetSubElement(subElement) {
    // Override
    this.fSubElement = null;
  }

  // Drag & drop
  IsDraggable() {
    return this.fDragable;
  }

  SetDraggable(dragable) {
    this.fDragable = dragable;
  }

  // Control Interaction
  // If an element is a control
  // * StartInteractWithElement gets called on mousedown
  // * DoInteractWithElements gets called as mouse moves (with mousedown)
  // * GeneratesInteractiveCmd allows the control to issue a command as it is manipulated
  IsControl() {
    return this.fControl;
  }

  SetIsControl(isControl) {
    this.fControl = isControl;
  }

  // Command that is fired while control is manipulated
  GeneratesInteractiveCmd() {
    return this.fCtrlInteractiveCmd;
  }

  SetGenerateInteractiveCmd(generateCmd) {
    this.fCtrlInteractiveCmd = generateCmd;
  }

  // Override this
  DoTimerFire() {}

  // Called on mouse down on control
  // Override this
  StartInteractWithElement(xCanvas, yCanvas, xPanel, yPanel, shiftDown) {
    return true;
  }

  // Called on mouse move over control (with mouse down)
  // Override this
  DoInteractWithElement(x, y) {}

  // When a control is released a command can be issued (on mouseup)
  GetControlReleaseCmdCode() {
    return this.fControlReleaseCmdCode;
  }

  SetControlReleaseCmdCode(cmdCode) {
    this.fControlReleaseCmdCode = cmdCode;
  }

  // Get the mouse position and convert/clip it to local (element) coordinates
  InteractWithElement(x, y) {
    var xPanel = this.GetPositionX();
    var yPanel = this.GetPositionY();

    var adjustX = x - xPanel;
    var adjustY = y - yPanel;
    var theWidth = this.GetWidth();
    var theHeight = this.GetHeight();

    if (adjustX < 0) adjustX = 0;
    else if (adjustX > theWidth) adjustX = theWidth;

    if (adjustY < 0) adjustY = 0;
    else if (adjustY > theHeight) adjustY = theHeight;

    this.DoInteractWithElement(adjustX, adjustY);
  }

  // End of control handling calls
  SelectAll() {}

  CreateBoundingHitBox(bufferLeft = 0, bufferRight = 0, bufferTop = 0, bufferBottom = 0) {
    var elemPosX = this.GetPositionX();
    var elemPosY = this.GetPositionY();

    var hitLeft = elemPosX - bufferLeft;
    var hitTop = elemPosY - bufferTop;
    var hitRight = elemPosX + this.GetWidth() + bufferRight;
    var hitBottom = elemPosY + this.GetHeight() + bufferBottom;

    var hitBox = new QRect();
    hitBox.InitRect(hitLeft, hitTop, hitRight, hitBottom);

    return hitBox;
  }

  GetHitBox() {
    if (this.fHitBox == null)
      return this.CreateBoundingHitBox(); // should we store this? not doing so for now to model existing behavior
    else return this.fHitBox;
    //if (this.fHitBox == null)
    //	this.fHitBox = this.CreateHitBox();
    //return this.fHitBox;
  }

  //var gTrackMouse = false;
  // Click testing
  HitTest(x, y, panelHitTest) {
    if (this.fAcceptsClicks) {
      var hitBox = this.GetHitBox();

      var leftHitBox = hitBox.fLeft;
      var topHitBox = hitBox.fTop;
      var rightHitBox = hitBox.fRight;
      var bottomHitBox = hitBox.fBottom;

      if (x >= leftHitBox && x <= rightHitBox && y >= topHitBox && y <= bottomHitBox) {
        if (this.fEnabled) panelHitTest.fElementHit = this;
        else panelHitTest.fDisabledElementHit = this;
        if (this.fElements) {
          for (var anElementIdx in this.fElements) {
            if (this.fElements[anElementIdx].IsElementActive(panelHitTest.fPanelHit))
              this.fElements[anElementIdx].HitTest(x, y, panelHitTest);
          }
        }
      }
    }
  }

  IsElementActive(panelHit) {
    var eLayer = this.GetLayer();
    var renderMode = panelHit.GetRenderMode();
    var isActive;

    switch (renderMode) {
      case enumPanelRenderMode.all:
        isActive = eLayer == enumElementLayer.content;
        // we are rendering all content (so master elements are inactive, but we are checking for the exception "link" elements
        if (!isActive && eLayer == enumElementLayer.master)
          isActive = this.IsActiveOutsideRenderLayer();
        break;
      case enumPanelRenderMode.contentOnly:
        isActive = eLayer == enumElementLayer.content;
        break;
      case enumPanelRenderMode.backgroundAndGhostChart:
      case enumPanelRenderMode.masterOnly:
        isActive = eLayer == enumElementLayer.master;
        break;
    }

    return isActive;
  }

  DoHandleMouseUp() {
    // Override if you need to do something
  }

  GenerateAdditionalCmdParameters() {
    // override this fxn if an element has a standardized set of additional parameters, will be subclassed,
    // or if the additional cmd parameter values are unknown until the cmd is executed.
  }

  //TODO: Add routines for generalized cmd parameters (e.g. AddIndexParam, AddNameParam, etc...)
  AddCmdParameter(key, value) {
    if (this.fAdditionalCmdParameters == null) this.fAdditionalCmdParameters = {};
    this.fAdditionalCmdParameters[key] = value;
  }

  DoPostRender(drawBuffer) {
    return false;
  }

  DoPostAltRender(drawBuffer) {
    return false;
  }

  DoRenderElement(drawBuffer) {
    // Override this method
  }

  RenderSelectionHighlight(drawBuffer, fillColor) {
    var ctx = drawBuffer.getContext("2d");

    ctx.save();

    var borderThickness = 2;
    //var borderWidth = borderThickness/2;

    ctx.strokeStyle = "#000000";
    ctx.fillStyle = fillColor;
    ctx.lineWidth = borderThickness;
    ctx.lineJoin = "round";

    var xPanel = this.GetPositionX();
    var yPanel = this.GetPositionY();

    var borderPlacement = borderThickness / 2 + 3;
    var borderBoxLeft = xPanel - borderPlacement;
    var borderBoxTop = yPanel - borderPlacement;
    var borderBoxWidth = this.GetWidth() + borderPlacement * 2;
    var borderBoxHeight = this.GetHeight() + borderPlacement * 2;

    ctx.beginPath();
    ctx.arc(borderBoxLeft, borderBoxTop, 3, 0, 2 * Math.PI);
    ctx.moveTo(borderBoxLeft + borderBoxWidth + 3, borderBoxTop);
    ctx.arc(borderBoxLeft + borderBoxWidth, borderBoxTop, 3, 0, 2 * Math.PI);
    ctx.moveTo(borderBoxLeft + borderBoxWidth + 3, borderBoxTop + borderBoxHeight);
    ctx.arc(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight, 3, 0, 2 * Math.PI);
    ctx.moveTo(borderBoxLeft + 3, borderBoxTop + borderBoxHeight);
    ctx.arc(borderBoxLeft, borderBoxTop + borderBoxHeight, 3, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();

    /*
	var borderThickness = 4;
	var borderWidth = borderThickness/2;

	ctx.strokeStyle = "#00FF00";
	ctx.lineWidth= borderThickness;
	ctx.lineJoin = 'round';

	var borderPlacement = borderThickness/2;
	var borderBoxLeft = this.fHorzOffset - borderPlacement;
	var borderBoxTop = this.fVertOffset - borderPlacement;
	var borderBoxWidth = this.fWidth + borderPlacement * 2;
	var borderBoxHeight = this.fHeight + borderPlacement * 2;

	ctx.beginPath();
    ctx.moveTo(borderBoxLeft,borderBoxTop);
    ctx.lineTo(borderBoxLeft+borderBoxWidth,borderBoxTop);
    ctx.lineTo(borderBoxLeft+borderBoxWidth,borderBoxTop+borderBoxHeight);
    ctx.lineTo(borderBoxLeft,borderBoxTop+borderBoxHeight);
    ctx.lineTo(borderBoxLeft,borderBoxTop);
    ctx.closePath();
    ctx.stroke();
	*/

    ctx.restore();
  }

  DoRenderShadow(drawBuffer, borderWidth) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var width = this.GetWidth();
    var height = this.GetHeight();

    ctx.fillStyle = "rgba(255, 255, 255, 1.0)";
    ctx.shadowOffsetX = 3;
    ctx.shadowOffsetY = 3;
    ctx.shadowBlur = 8;
    ctx.shadowColor = "rgba(120, 120, 120, 1.0)";

    var xElement = this.GetPositionX();
    var yElement = this.GetPositionY();

    var shadowBoxLeft = xElement - borderWidth;
    var shadowBoxTop = yElement - borderWidth;
    var shadowBoxWidth = width + borderWidth * 2;
    var shadowBoxHeight = height + borderWidth * 2;

    ctx.fillRect(shadowBoxLeft, shadowBoxTop, shadowBoxWidth, shadowBoxHeight);
    ctx.restore();
  }

  //var kDoubleBorderWidthAdder = 3;
  GetBorderWidth(borderStyle) {
    var borderWidth = this.GetBorderThickness();
    return CalcBorderWidth(borderStyle, borderWidth, false);
    /*
	var borderSize = Math.floor(borderWidth/2) + ThicknessAdjuster(borderWidth);
	switch (borderStyle)
	{
		case enumElementBorderStyle.noBorder:
			borderSize = 0;
			break;
		case enumElementBorderStyle.singleBorder:
			break;
		case enumElementBorderStyle.doubleBorder:
			borderSize = borderSize + kDoubleBorderWidthAdder;
			break;
	}

	return borderSize;
*/
  }

  DoRenderBorder(drawBuffer) {
    var borderStyle = this.GetBorderStyle();
    if (borderStyle === enumElementBorderStyle.noBorder) return;

    var ctx = drawBuffer.getContext("2d");
    var borderThickness = this.GetBorderThickness();
    var width = this.GetWidth();
    var height = this.GetHeight();
    var borderColor = this.GetBorderColor();

    ctx.strokeStyle = borderColor;
    ctx.lineWidth = borderThickness;

    var borderPlacement = this.GetBorderWidth(enumElementBorderStyle.singleBorder);

    var xElement = this.GetPositionX();
    var yElement = this.GetPositionY();

    var borderBoxLeft = xElement - borderPlacement;
    var borderBoxTop = yElement - borderPlacement;
    var borderBoxWidth = width + borderPlacement * 2;
    var borderBoxHeight = height + borderPlacement * 2;

    ctx.save();

    if (borderStyle !== enumElementBorderStyle.roundBorder) {
      ctx.linejoin = "miter";
      if (borderStyle == enumElementBorderStyle.dashedBorder) ctx.setLineDash([5, 2]);
      ctx.beginPath();
      ctx.moveTo(borderBoxLeft, borderBoxTop);
      ctx.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop);
      ctx.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight);
      ctx.lineTo(borderBoxLeft, borderBoxTop + borderBoxHeight);
      ctx.lineTo(borderBoxLeft, borderBoxTop);
      ctx.closePath();
      ctx.stroke();
    }

    if (borderStyle === enumElementBorderStyle.doubleBorder) {
      //borderPlacement = borderThickness + 2 + borderThickness/2;
      // I believe this is broken
      var borderWidth = this.GetBorderWidth(borderStyle);
      var borderBoxLeft = xElement - borderWidth;
      var borderBoxTop = yElement - borderWidth;
      var borderBoxWidth = width + borderWidth * 2;
      var borderBoxHeight = height + borderWidth * 2;

      ctx.beginPath();
      ctx.moveTo(borderBoxLeft, borderBoxTop);
      ctx.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop);
      ctx.lineTo(borderBoxLeft + borderBoxWidth, borderBoxTop + borderBoxHeight);
      ctx.lineTo(borderBoxLeft, borderBoxTop + borderBoxHeight);
      ctx.lineTo(borderBoxLeft, borderBoxTop);
      ctx.closePath();
      ctx.stroke();
    }

    if (borderStyle === enumElementBorderStyle.roundBorder) {
      var sx = borderBoxLeft;
      var sy = borderBoxTop;
      var x0 = sx;
      var y0 = sy;
      var x1 = borderBoxLeft + borderBoxWidth;
      var y1 = borderBoxTop + borderBoxHeight;

      var r = this.fBorderRadius || Div2Floor(this.fHeight);

      var w = x1 - x0;
      var h = y1 - y0;
      if (r > w / 2) r = w / 2;
      if (r > h / 2) r = h / 2;

      var clippedRegion = new Path2D();

      //ctx.beginPath();
      clippedRegion.moveTo(x1 - r, y0);
      clippedRegion.quadraticCurveTo(x1, y0, x1, y0 + r);
      clippedRegion.lineTo(x1, y1 - r);
      clippedRegion.quadraticCurveTo(x1, y1, x1 - r, y1);
      clippedRegion.lineTo(x0 + r, y1);
      clippedRegion.quadraticCurveTo(x0, y1, x0, y1 - r);
      clippedRegion.lineTo(x0, y0 + r);
      clippedRegion.quadraticCurveTo(x0, y0, x0 + r, y0);
      clippedRegion.closePath();
      if (borderThickness > 0) ctx.stroke(clippedRegion);

      this.fClippedRegion = clippedRegion;
    }

    ctx.restore();
  }

  SetClippingRegion(sx, sy, ex, ey) {
    this.fClippedRegion = CreatePath2D(sx, sy, ex, ey);
    this.fClippedRegionCoords = { sx: sx, sy: sy, ex: ex, ey: ey };
  }

  RenderShadowAndBorder(drawBuffer) {
    if (this.GetShadowOn()) this.DoRenderShadow(drawBuffer);

    this.DoRenderBorder(drawBuffer);
  }

  PrepRender() {
    // Override this
  }

  RenderElement(drawBuffer) {
    var needsHighlightRender = true;
    var isSelected = this.IsSelected();
    var cntlPtFillColor = "#ffffff";

    if (this.GetRenderHighlightBeneathText() && isSelected) {
      this.RenderSelectionHighlight(drawBuffer, uFramelessPanelColorDarker);
      needsHighlightRender = false;
    }

    var ctx = drawBuffer.getContext("2d");

    this.RenderShadowAndBorder(drawBuffer);
    ctx.save();
    if (this.fClippedRegion) ctx.clip(this.fClippedRegion);
    this.DoRenderElement(drawBuffer);
    ctx.restore();
    if (needsHighlightRender && isSelected) {
      this.RenderSelectionHighlight(drawBuffer, cntlPtFillColor);
    }
  }

  // Called when user starts to drag an element
  GetDragStartCmdCode() {
    return this.fDragStartCmd;
  }

  SetDragStartCmdCode(cmdCode) {
    this.fDragStartCmd = cmdCode;
  }

  // Command Handling
  GetCmdCode() {
    return this.fCmdCode;
  }

  SetCmdCode(cmdCode) {
    this.fCmdCode = cmdCode;
  }

  // Apr2
  MatchCmdShortCut(keyInfo) {
    var cmdSC = this.fCmdShortCut;
    if (cmdSC == null) return false;

    // Return key is a weird case
    if (cmdSC == kReturnKey) {
      if (keyInfo.keyCode == kReturnKey) return true;
    }

    var match = false;
    if (keyInfo.funcKey == this.fIsFuncShortCut) {
      if (keyInfo.charCode == cmdSC || keyInfo.keyCode == cmdSC) {
        // || keyInfo.keyCode == cmdSC)
        var reqModsKeys = this.fCmdShortCutModKeys;
        switch (reqModsKeys) {
          case enumShortCutModKeys.none:
            if (keyInfo.ctrlKey == false && keyInfo.shiftKey == false) match = true;
            break;
          case enumShortCutModKeys.ctrl:
            if (keyInfo.ctrlKey == true) match = true;
            break;
          case enumShortCutModKeys.shift:
            if (keyInfo.shiftKey == true) match = true;
            break;
          case enumShortCutModKeys.ctrlshift:
            if (keyInfo.shiftKey && keyInfo.ctrlKey) match = true;
            break;
        }
      }
    }

    return match;
  }

  GetCmdShortCutText() {
    return this.fCmdShortCutText;
  }

  SetCmdShortCut(cmdShortCut, modKeys, cmdShortCutText) {
    this.fCmdShortCut = cmdShortCut;
    this.fCmdShortCutModKeys = modKeys;
    this.fCmdShortCutText = cmdShortCutText;
  }

  GetDblClickCmd() {
    return this.fDblClickCmd;
  }

  SetDblClickCmd(cmdCode) {
    this.fDblClickCmd = cmdCode;
  }

  GetImageElement(imageIdx, imageW, imageH, xPos, yPos) {
    var imageMgr = this.fWSMgr.GetImageMgr();
    var image = imageMgr.GetIndexImage(imageIdx);
    const QImageElement = require("./QImageElement.js").QImageElement;
    var imageElement = new QImageElement();
    imageElement.fImageMgr = imageMgr;
    imageElement.fImageIndex = imageIdx;
    imageElement.SetImage(image);
    imageElement.SetDisabledImage();
    imageElement.SizeElement(imageW, imageH);
    imageElement.PositionElement(xPos, yPos);
    return imageElement;
  }

  //=================================================================================================
  // End QHoverMsg
  GetHoverMessage() {
    var theCode = this.GetHoverCode();
    var rawHoverCode = this.GetRawHoverValue();
    if (theCode == null && rawHoverCode == null) return null;

    var rawMessage;
    if (theCode && theCode.length > 0 && theCode[0] === "!") {
      rawMessage = theCode; // .substring(1);
    } else if (rawHoverCode && rawHoverCode.length > 0) {
      rawMessage = rawHoverCode;
    } else {
      rawMessage = getHoverTip(theCode);
    }

    var shortcutText = this.GetCmdShortCutText();

    var theMessage = new QHoverMsg();
    theMessage.InitMsg(rawMessage, shortcutText);

    return theMessage;
  }

  GetHoverCode() {
    return this.fHoverCode;
  }

  SetHoverCode(hoverCode) {
    this.fHoverCode = hoverCode;
  }

  // used for creating dynamic hover values that dont require localization i.e long values in a user generated drop down picker or chart data
  SetRawHoverValue(rawValue) {
    this.fRawHoverValue = rawValue;
  }

  GetRawHoverValue() {
    return this.fRawHoverValue;
  }

  // Resize
  SetResizeBehavior(pinLeft, pinTop, pinRight, pinBottom) {
    var resizeBehavior = this.GetResizeBehavior();
    resizeBehavior.fPinLeft = pinLeft;
    resizeBehavior.fPinTop = pinTop;
    resizeBehavior.fPinRight = pinRight;
    resizeBehavior.fPinBottom = pinBottom;
    this.fElementResizeBehavior = resizeBehavior;
  }

  GetResizeBehavior() {
    if (this.fElementResizeBehavior == null) this.fElementResizeBehavior = new QResizeBehavior();
    return this.fElementResizeBehavior;
  }

  Resize(origParentWidth, origParentHeight, newParentWidth, newParentHeight) {
    var resizeBehavior = this.GetResizeBehavior();
    var pinLeft = resizeBehavior.fPinLeft;
    var pinRight = resizeBehavior.fPinRight;
    var pinTop = resizeBehavior.fPinTop;
    var pinBottom = resizeBehavior.fPinBottom;

    var newHSize = this.GetWidth();
    var newVSize = this.GetHeight();
    var newPosX = this.GetPositionX();
    var newPosY = this.GetPositionY();

    if (pinLeft && pinRight) {
      // Stretch right
      //var xFactor = newParentWidth / origParentWidth;
      //newHSize = Math.round(newHSize * xFactor);
      newHSize = newHSize + (newParentWidth - origParentWidth);
      if (newHSize < 1) newHSize = 1;
    } else if (pinLeft && !pinRight) {
      // Do not move or resize
    } else if (!pinLeft && pinRight) {
      // Move right
      newPosX = newPosX + (newParentWidth - origParentWidth);
      if (newPosX < 0) newPosX = 0;
    }

    if (pinTop && pinBottom) {
      // Stretch down
      //var yFactor = newParentHeight / origParentHeight;
      //newVSize = Math.round(newVSize * yFactor);
      newVSize = newVSize + (newParentHeight - origParentHeight);
      if (newVSize < 1) newVSize = 1;
    } else if (pinTop && !pinBottom) {
      // Do not move or resize
    } else if (!pinTop && pinBottom) {
      newPosY = newPosY + (newParentHeight - origParentHeight);
      if (newPosY < 0) newPosY = 0;
    }

    this.SizeElement(newHSize, newVSize);
    this.PositionElement(newPosX, newPosY);
  }

  // Called by assemble command
  // this fxn is responsible for assigning additional command parameters from the source element, to the qcmd being executed
  SetCmdParameters(aCmd) {
    this.GenerateAdditionalCmdParameters();
    if (this.fAdditionalCmdParameters != null) {
      for (var paramKey in this.fAdditionalCmdParameters)
        aCmd[paramKey] = this.fAdditionalCmdParameters[paramKey];
    }
  }

  // TODO: This concept needs further review. Could see it being useful in several areas (dropdowns being one)
  PassCmdParameters(sourceElement) {
    sourceElement.GenerateAdditionalCmdParameters();
    var additionalParams = sourceElement.fAdditionalCmdParameters;
    if (additionalParams != null) {
      for (var aKey in additionalParams) {
        this.AddCmdParameter(aKey, additionalParams[aKey]);
      }
    }
  }

  SetElementGroup(elementGroup) {
    if (this.fElementGroup != null) this.fElementGroup.PRemoveElementFromGroup(this);

    this.fElementGroup = elementGroup;
    if (elementGroup != null) elementGroup.PAddElementToGroup(this);
  }

  GetElementGroup() {
    return this.fElementGroup;
  }

  SetZPlane(zPlane) {
    this.fZPlane = zPlane;
    //TODO: Zplane must be set when the item is spawned. This won't change it once it is pushed into a rendering array. Fix?
  }

  GetZPlane() {
    return this.fZPlane;
  }

  WantsKeyboardInput() {
    return this.fWantsKeyboardInput;
  }

  SetWantsKeyboardInput(wantsKeyboard) {
    this.fWantsKeyboardInput = wantsKeyboard;
  }

  DoEnterKeyboardTarget(enterAction) {
    // Override this
  }

  EnterKeyboardTarget(enterAction) {
    //this["keyboard"] = true;
    this.DoEnterKeyboardTarget(enterAction);
  }

  DoExitKeyboardTarget(targetPanel, previousPanel) {}

  ExitKeyboardTarget(targetPanel, previousPanel) {
    //this["keyboard"] = false;
    this.DoExitKeyboardTarget(targetPanel, previousPanel);
  }

  ElementHandleKeyboard(keyInfo) {
    // Override this
    return false;
  }

  GetElementState() {
    // for rebuilding element that was removed on update back to its last state
  }

  //=================================================================================================
  // Clipboard support
  InEditMode() {
    return false;
  }

  IsTextSelection() {
    return false;
  }

  //=================================================================================================
  // Autosizing methods and functions
  CreateMeasureBuffer() {
    CreateMeasureBuffer();

    if (this.fMeasureBuffer == null) this.fMeasureBuffer = Globals._measureBuffer;
  }

  //=================================================================================================
  DoCalculateMinWidth() {
    // Override this
  }

  CalcMinWidth() {
    this.CreateMeasureBuffer();
    return this.DoCalculateMinWidth();
  }

  //=================================================================================================
  // SVG Rendering
  DoAltRender(altCanvas) {
    var oN = this.ObjectName();
    console.log("DoAltRender Missing:", oN);
    // Override this!
  }

  AltRender(altCanvas) {
    if (!this.IsShown()) return;

    this.DoAltRender(altCanvas);
  }

  //
  // RenderMode
  GetLayer() {
    return this.fLayer;
  }

  SetLayer(theLayer) {
    this.fLayer = theLayer;
  }

  // HIDEBK
  OverrideHideMaster() {
    return false;
  }

  IsActiveOutsideRenderLayer() {
    return false;
  }

  HasActiveSubs() {
    return false;
  }

  //=================================================================================================
  // Debugging
  ObjectName() {
    return "QElement";
  }

  //=================================================================================================
  // Tablet/Smart Phone - override and return true if you want the onscreen keypad to come up when the
  // element is selected
  WantsOnscreenKeypad() {
    return false;
  }

  GetRootElement() {
    var testElem = this;
    var parentElem = testElem.fParentElement;
    while (parentElem != null) {
      testElem = parentElem;
      parentElem = testElem.fParentElement;
    }
    return testElem;
  }

  GetWSMgrRef() {
    var elem = this.GetRootElement();
    var parent = elem.GetParentPanelRef();
    return parent.fWSMgr;
    //Override this if needed
  }

  //======================================================================================================================
  // Element dragging between panels
  // allowed targets
  SetElementDragInfo(srcPanel, dstPanel, releaseCmd, startDragCmd, hideTargetIndicator) {
    var finishCmd = releaseCmd ? releaseCmd : "ElementDragComplete";
    var elemDragInfo = new QElemDragInfoObj();
    elemDragInfo.InitDragInfoObj(srcPanel, dstPanel, finishCmd, startDragCmd);
    if (hideTargetIndicator) elemDragInfo.SetHideTargetIndicator(hideTargetIndicator);
    this.SetControlReleaseCmdCode(finishCmd);
    this.SetDragStartCmdCode(startDragCmd);
    this.fElementDragInfo = elemDragInfo;
    return elemDragInfo;
  }

  GetElementDragInfo() {
    return this.fElementDragInfo;
  }

  IsDragReady() {
    return true;
  }

  GetDragPanelClass() {
    // return new QElementDragPanel();
  }

  GetDragClone(draggerPanel) {
    return this; // override this to return new element instance for pushing to dragger panel
  }
}
